import { providerBaseModel } from './crud';

export * from './types';

export const useProvidersById = providerBaseModel.fetchById();
export const useProvidersByIds = providerBaseModel.fetchByIds();
export const useProvidersMany = providerBaseModel.fetchMany();
export const useProvidersManyInfiniteQuery = providerBaseModel.fetchPaginated();
export const useProvidersUpdateOne = providerBaseModel.edit();
export const useProvidersCreateOne = providerBaseModel.create();
export const useProvidersRemoveOne = providerBaseModel.delete();
export const useProvidersRemoveByIds = providerBaseModel.deleteByIds();

export const useProvidersByIdV2 = providerBaseModel.fetchByIdV2();
export const useProvidersByIdsV2 = providerBaseModel.fetchByIdsV2();
export const useProvidersManyV2 = providerBaseModel.fetchManyV2();
export const useProvidersManyInfiniteQueryV2 =
  providerBaseModel.fetchPaginatedV2();
export const useProvidersUpdateOneV2 = providerBaseModel.editV2();
export const useProvidersCreateOneV2 = providerBaseModel.createV2();
export const useProvidersRemoveOneV2 = providerBaseModel.deleteV2();
export const useProvidersRemoveByIdsV2 = providerBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useProviderById = providerBaseModel.fetchById();
export const useProviderByIds = providerBaseModel.fetchByIds();
export const useProviderMany = providerBaseModel.fetchMany();
export const useProviderPagination = providerBaseModel.fetchPaginated();
export const useProviderUpdateOne = providerBaseModel.edit();
export const useProviderCreateOne = providerBaseModel.create();
export const useProviderRemoveOne = providerBaseModel.delete();
export const useProviderRemoveByIds = providerBaseModel.deleteByIds();

export const useProviderByIdV2 = providerBaseModel.fetchByIdV2();
export const useProviderByIdsV2 = providerBaseModel.fetchByIdsV2();
export const useProviderManyV2 = providerBaseModel.fetchManyV2();
export const useProviderPaginationV2 = providerBaseModel.fetchPaginatedV2();
export const useProviderUpdateOneV2 = providerBaseModel.editV2();
export const useProviderCreateOneV2 = providerBaseModel.createV2();
export const useProviderRemoveOneV2 = providerBaseModel.deleteV2();
export const useProviderRemoveByIdsV2 = providerBaseModel.deleteByIdsV2();
